define('jst',['text', 'underscore'], function (text, _) {
  'use strict';

  var buildMap = {};

  var utils = {
      jsEscape: function (content) {
        return content.replace(/(['\\])/g, '\\$1')
            .replace(/[\f]/g, "\\f")
            .replace(/[\b]/g, "\\b")
            .replace(/[\n]/g, "\\n")
            .replace(/[\t]/g, "\\t")
            .replace(/[\r]/g, "\\r")
            .replace(/[\u2028]/g, "\\u2028")
            .replace(/[\u2029]/g, "\\u2029");
    }
  };

  return {

    load : function(name, req, onLoad, config) {

      // Add .jst extension, and ensure correct path
      var path = 'templates/' + name + '.jst';

        text.load(path, req, function(data){
            if (config.isBuild) {
                buildMap[name] = data;
                onLoad(data);
            } else {
                onLoad(_.template(data));
            }
        }, config);
    },


    write: function (pluginName, moduleName, write, config) {
        if(moduleName in buildMap){
            var content = utils.jsEscape(buildMap[moduleName]);
            write.asModule(pluginName + "!" + moduleName, "define(function () { var _ = require('underscore');\nvar t = require('translate');\nreturn _.template('" + content + "');\n });\n");
        }
    }


  };

});


